// Depends
import { route, group, subGroup, meta } from '@/helpers/routes'

import Create from './form/form'
import Index from './index/index'

const parkingRoutes = [
  route('create', '/create', Create, meta('Adicionar Empréstimo', true, 'guest')),
  route('edit', '/:id/edit', Create, meta('Editar Empréstimo', true, 'guest')),
  route('index', '/index', Index, meta('Lista de Empréstimo', true, 'guest'))
]

export default [
  ...group('/app', [
    ...subGroup('/parking', parkingRoutes)
  ])
]



// WEBPACK FOOTER //
// ./src/app/dweller/parking/routes.js